export default "__VITE_ASSET__BzX9znBg__"